const path = require("path")
module.exports = {
  i18n: {
    localeDetection: false,
    defaultLocale: "en",
    locales: ["en"],
    ignoreRoutes: ["/", "/*"],
    localePath: process.env.ENV !== "development" ? path.join(__dirname, "./src/i18n/") : "./src/i18n",
  },
}
